import React, { useEffect } from 'react'

import { AiOutlineUser, AiOutlineCreditCard, AiOutlineArrowLeft } from 'react-icons/ai'
import { BiHelpCircle } from 'react-icons/bi'
import history from '../../../../services/history'

import { BackButton, Container, ProfileConfigButton } from './styles'

interface ProfileSwitchProps {
  type: string
  switchType(type: 'geral' | 'payment' | 'help'): void
}

const ProfileSwitch: React.FC<ProfileSwitchProps> = ({ type, switchType }) => {
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    const titleBar = queryParams.get('title')

    if (titleBar === 'help') {
      switchType('help')
    }
  }, [switchType])

  return (
    <Container>
      <BackButton onClick={() => history.goBack()}>
        <AiOutlineArrowLeft /> Voltar
      </BackButton>
      {type === 'geral' && (
        <ProfileConfigButton onClick={() => switchType('geral')} selected={type === 'geral'}>
          <AiOutlineUser /> Meus dados
        </ProfileConfigButton>
      )}
      {type === 'payment' && (
        <ProfileConfigButton onClick={() => switchType('payment')} selected={type === 'payment'}>
          <AiOutlineCreditCard /> Meus pedidos
        </ProfileConfigButton>
      )}
      {type === 'help' && (
        <ProfileConfigButton onClick={() => switchType('help')} selected={type === 'help'}>
          <BiHelpCircle /> Ajuda
        </ProfileConfigButton>
      )}
    </Container>
  )
}

export default ProfileSwitch
